import React from "react"
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  redirect,
} from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// authProtectedRoutes
import DashboardPage from "../pages/dashboard/DashboardPage"
import DocumentsPage from "pages/documents/DocumentsPage"
import FoldersPage from "pages/folders/FoldersPage"
import SettingPage from "pages/setting/SettingPage"
import VerticalLayout from "components/VerticalLayout"
import Authmiddleware from "./route"
import AllowedIPsPage from "pages/setting/allowedIPs/AllowedIPsPage"
import UserProfilePage from "pages/user-profile/UserProfilePage"
import SecurityProfilePage from "pages/user-profile/SecurityProfilePage"
import UpdateProfilePage from "pages/user-profile/UpdateProfilePage"
import NonAuthLayout from "components/NonAuthLayout"
import ClientsPage from "pages/clients/ClientsPage"
import PackagesPage from "pages/packages/PackagesPage"
import NotAllowedPage from "pages/not-allwoed"
import NotFoundPage from "pages/not-found"
import EmployeesPage from "pages/employees/EmployeesPage"
import AnalysisPage from "pages/analysis/AnalysisPage"
import FolderTemplatePage from "pages/setting/folderTemplate/FolderTemplatePage"
import RedirectRouter from "./RedirectRouter"

const authProtectedRoutes = [
  // { path: "/dashboard", element: <DashboardPage /> },
  { path: "/documents", element: <DocumentsPage /> },
  { path: "/folders", element: <FoldersPage /> },
  { path: "/clients", element: <ClientsPage /> },
  { path: "/packages", element: <PackagesPage /> },
  { path: "/employees", element: <EmployeesPage /> },
  { path: "/analysis", element: <AnalysisPage /> },
  {
    path: "/settings",
    element: <SettingPage />,
    children: [
      { index: true, element: <AllowedIPsPage /> },
      { path: "templates", element: <FolderTemplatePage /> },
    ],
  },
  {
    path: "/profile",
    element: <UserProfilePage />,
    children: [
      { index: true, element: <UpdateProfilePage /> },
      { path: "security", element: <SecurityProfilePage /> },
    ],
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    element: <RedirectRouter />,
  },
]

const publicRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/forgot-password", element: <ForgetPwd /> },
]

const AppRouter = createBrowserRouter([
  // private routes
  {
    path: "/",
    element: (
      <Authmiddleware>
        <VerticalLayout />
      </Authmiddleware>
    ),
    children: authProtectedRoutes,
  },
  // public routes
  {
    path: "/",
    element: <NonAuthLayout>{<Outlet />}</NonAuthLayout>,
    children: publicRoutes,
  },
  { path: "/not-allowed", element: <NotAllowedPage /> },
  { path: "*", element: <NotFoundPage /> },
])

export default AppRouter
